/* ═══ LA BARRA DEL CATÁLOGO — filtro + índice ════════════════════════════════
   Una tienda de cinco objetos no necesita un buscador con facetas; necesita
   llegar rápido y saber dónde está. Esta barra hace las dos y nada más.

   TRES DECISIONES QUE NO SON DE GUSTO:

   · EL ALTO DE LA CABECERA SE MIDE, NO SE ESCRIBE. La barra se pega DEBAJO del
     encabezado, y ese encabezado cambia de alto (`--n` lo condensa al bajar).
     Un `top:74px` a mano acierta hoy y deja un escalón el día que cambie el
     relleno. Se publica `--alto-nav` y el CSS lo lee.

   · SE OCULTA CON UNA CLASE, NO CON EL ATRIBUTO `hidden`. `hidden` vale
     `display:none` de hoja de usuario y CUALQUIER `display` de autor le gana
     —y estas secciones traen el suyo—, así que el atributo se pondría, no daría
     ningún error y la sección seguiría a la vista. Ya pasó en esta casa.

   · EL FILTRO VIVE EN `?ver=`, NO EN EL ANCLA. La portada enlaza a
     `tienda.html#journals` esperando que la página BAJE hasta ahí; si el filtro
     usara el ancla, esos enlaces cambiarían de significado. Con un parámetro
     aparte los dos conviven: se puede compartir «solo los journals» y el enlace
     de la portada sigue haciendo lo que hacía.                               */
(() => {
  const barra = document.getElementById('barra-cat');
  if (!barra) return;

  /* 🔴 LOS BOTONES NO SON SOLO LOS DE LA BARRA. El menú de entrada filtra con
     este mismo motor: dos dueños para el mismo gesto es un gesto roto, y aquí
     el gesto es «enséñame los journals». Se recogen del documento entero y el
     estado se pinta en todos a la vez — si el menú de arriba y la barra de
     abajo pudieran decir cosas distintas, uno de los dos estaría mintiendo. */
  const botones = [...document.querySelectorAll('[data-ver]')];
  const cuenta  = document.getElementById('cuenta-n');
  const rotulo  = barra.querySelector('.cuenta-cat span');

  /* 🔴 4-sep — EL FILTRO YA NO ESCONDE SECCIONES, ESCONDE PIEZAS.
     Hasta hoy el catálogo eran tres secciones —Planners, Journals, Objetos— y
     filtrar era apagar dos losas enteras. Marisa pidió una tienda corrida, «que
     entres en menos de dos clics a ver todos los productos», así que las cinco
     piezas viven en UNA rejilla y cada una declara su familia en `data-fam`.
     Filtrar es ahora esconder fichas sueltas, y la rejilla se recompone sola
     sin dejar los huecos que dejaba una sección de un solo producto. */
  const piezasTodas = [...document.querySelectorAll('[data-fam]')];
  const entrada     = document.querySelector('.enc-shop');

  /* ── el alto real de la cabecera ───────────────────────────────────────── */
  const nav = document.querySelector('.nav');
  const mideNav = () => {
    const r = document.documentElement.style;
    r.setProperty('--alto-nav',   Math.round(nav ? nav.getBoundingClientRect().height : 0) + 'px');
    /* 🔴 Y EL ALTO DE ESTA BARRA TAMBIÉN, porque al aparecer ROMPIÓ los enlaces
       de la portada. `tienda.html#journals` cae con `scroll-margin-top:78px`,
       calibrado para una cabecera sola; con la barra encima hay 124 px de
       cornisa y §Journals aterrizaba 46 px POR DEBAJO de ella — el título
       tapado, sin un solo error. Se mide y el CSS suma las dos. */
    r.setProperty('--alto-barra', Math.round(barra.getBoundingClientRect().height) + 'px');
  };
  mideNav();
  addEventListener('resize', mideNav);
  if ('ResizeObserver' in window) {
    const ro = new ResizeObserver(mideNav);
    if (nav) ro.observe(nav);
    ro.observe(barra);
  }

  const quieto = matchMedia('(prefers-reduced-motion: reduce)');
  const dela   = ver => piezasTodas.filter(p => p.dataset.fam === ver);
  const total  = piezasTodas.length;

  let actual = 'todo';

  function pinta(ver, mover) {
    actual = ver;
    const todo = ver === 'todo';

    piezasTodas.forEach(p => p.classList.toggle('cat-fuera', !todo && p.dataset.fam !== ver));

    botones.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.ver === ver)));

    const n = todo ? total : dela(ver).length;
    /* El número PULSA cuando cambia — el mismo aviso que ya da el contador de
       la bolsa, con los mismos fotogramas. Sólo si cambió: repintar el mismo
       número no es un evento, y un contador que late sin motivo es un tic.
       Se quita la clase, se fuerza el reflujo y se vuelve a poner, porque una
       animación de fotogramas no se reinicia sola si ya está corriendo. */
    if (cuenta.textContent !== String(n)) {
      cuenta.textContent = n;
      if (!quieto.matches) {
        cuenta.classList.remove('pulso');
        void cuenta.offsetWidth;
        cuenta.classList.add('pulso');
      }
    }
    rotulo.textContent = n === 1 ? 'pieza' : 'piezas';

    /* ── LAS PIEZAS QUE SE QUEDAN ENTRAN, NO APARECEN ──────────────────────
       El filtro de la biblioteca ya disuelve su estante; éste cortaba en seco.
       Mismo gesto, mismo movimiento.
       Sólo con `mover`: al cargar la página con `?ver=` no hay gesto que
       responder, y animar la primera pintura retrasaría el contenido sin que
       nadie hubiera pedido nada.
       🔴 UN SOLO REFLUJO PARA TODAS. Quitar la clase y leer `offsetWidth`
       dentro del bucle obligaría al navegador a recalcular la disposición una
       vez por pieza. Se limpian todas, se lee UNA vez, y se ponen todas. */
    if (mover && !quieto.matches) {
      const vivas = piezasTodas.filter(p => !p.classList.contains('cat-fuera'));
      vivas.forEach(p => p.classList.remove('cat-entra'));
      void barra.offsetWidth;
      vivas.forEach((p, i) => {
        p.style.setProperty('--i', Math.min(i, 7));
        p.classList.add('cat-entra');
        /* La clase se retira al acabar: con `both` se queda pegado el último
           fotograma, y un `translate` fijo le ganaría después al hover. */
        p.addEventListener('animationend',
          () => p.classList.remove('cat-entra'), { once: true });
      });
    }

    /* El filtro se guarda para poder compartirlo y para que el botón de atrás
       del navegador signifique algo. `replaceState` y no `pushState`: cada
       toque en un filtro no es un paso del recorrido, es el mismo sitio visto
       de otra manera. */
    const u = new URL(location);
    todo ? u.searchParams.delete('ver') : u.searchParams.set('ver', ver);
    history.replaceState(null, '', u);

    /* 🔴 AL FILTRAR HAY QUE VOLVER ARRIBA. Si alguien filtra estando a 3,000 px
       y lo que queda mide 900, el navegador lo deja mirando el pie: parece que
       el filtro vació la tienda. Se sube al principio del catálogo, nunca al
       principio del documento —el encabezado de la página ya se leyó—. */
    if (mover) {
      /* 🔴 EL ANCLA NO PUEDE SER LA BARRA: es fija, así que su `offsetTop` no
         dice dónde empieza el catálogo sino dónde está flotando. Se ancla al
         final del menú de entrada, que es un punto del documento y no se mueve. */
      const cor = (nav ? nav.getBoundingClientRect().height : 0)
                + barra.getBoundingClientRect().height;
      const y = entrada
        ? entrada.getBoundingClientRect().bottom + scrollY - cor
        : 0;
      scrollTo({ top: Math.max(0, y), behavior: quieto.matches ? 'auto' : 'smooth' });
    }
  }

  document.addEventListener('click', e => {
    const b = e.target.closest('[data-ver]');
    if (!b) return;
    /* Desde la barra, volver a pulsar lo puesto no hace nada. Desde el menú de
       entrada SÍ mueve: allí el botón no es un interruptor, es una puerta —
       quien lo pulsa quiere llegar, aunque ya estuviera filtrado. */
    const puesto = b.getAttribute('aria-pressed') === 'true';
    if (puesto && barra.contains(b)) return;
    pinta(b.dataset.ver, true);
  });

  /* ── EL «DÓNDE ESTOY» SE RETIRÓ (4-sep) ───────────────────────────────────
     Marcaba en la barra la familia por la que ibas pasando, y para eso hacían
     falta tres secciones que cruzaran la pantalla una detrás de otra. Con una
     rejilla corrida no hay por dónde ir pasando: las cinco piezas están en el
     mismo bloque. Un indicador que ya no puede cambiar de valor no informa,
     confunde. */

  /* ── LA BARRA, PUESTA DESDE EL PRIMER PÍXEL ───────────────────────────────
     🔴 Antes esperaba a que el menú de entrada saliera de pantalla: con los dos
     a la vista se leían como lo mismo dicho dos veces. Ese menú se quitó hoy, y
     sin él la espera dejaba la tienda SIN UN SOLO CONTROL a la vista al entrar
     — justo lo contrario de «que entres en menos de dos clics y elijas».
     Fija y no `sticky` sigue siendo lo correcto: en el flujo empujaría la
     página 50 px al aparecer, y eso se siente como un tirón. */
  barra.classList.add('barra-viva');

  /* Estado de entrada: `?ver=` si viene —de ahí cuelga el desplegable de
     «Shop»—, y si no, todo. Se pinta sin mover la página. */
  const pedido = new URL(location).searchParams.get('ver');
  pinta(piezasTodas.some(p => p.dataset.fam === pedido) ? pedido : 'todo', false);
})();
